<template>
  <div class="col-cell cursor fr mb20" @click="redirect(`detail?id=${goods.goods_id}`)">
    <el-image :src="goods.goods_img" lazy></el-image>
    <div class="ml10">
      <p class="ellipsis-2line fz12">{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
      <p class="mt10 fz12 orange" v-if="goods.goods_price">￥{{ goods.goods_price }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goods: Object
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.col-cell {
  width: 100%;

  .el-image {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ColCell.vue